import { render, staticRenderFns } from "./zgyh.vue?vue&type=template&id=f8862d5c&scoped=true&"
import script from "./zgyh.vue?vue&type=script&lang=js&"
export * from "./zgyh.vue?vue&type=script&lang=js&"
import style0 from "./zgyh.vue?vue&type=style&index=0&id=f8862d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8862d5c",
  null
  
)

export default component.exports